import React, { Component } from 'react';
import _ from 'lodash'
import Charts from '../../common/Charts'
import { Row, Col, Card , Spin} from 'antd';
import { DS_CHART_TOKENS, buildReferenceZones, buildTargetLine } from '../../../utils/chartTheme';
class Diabities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            industry_data: {},
            total_count: 0,
            loading: false,
            diabetic_prediabetic_percent: 0,
            diabetic_prediabetic_count: 0,
            diabitiesOverall: {filters:[], config:{}},
            diabitiesGender: {filters:[], config:{}},
            diabitiesLocation: {filters:[], config:{}},
            diabitiesCompany: {filters:[], config:{}},
            baseConfig : {
              filters: [],
              config: {
                  chart: {
                      renderTo: 'container',
                      type: 'column'
                  },
                  title: {
                      text: 'Diabetes',
                      align: 'left',
                      margin: 35
                  },
                  subtitle: { text: '', align: '' },
                  xAxis: {},
                  yAxis: {title: {text: 'Pre-diabetic/Diabetic in %'}, 
                    labels: {
                      formatter: function() {
                        return this.value + ' %';
                      }
                    },
                    plotBands: buildReferenceZones([
                      { from: 0, to: 20, color: DS_CHART_TOKENS.green100, label: 'Optimal' },
                      { from: 20, to: 50, color: DS_CHART_TOKENS.amber100, label: 'Monitor' },
                      { from: 50, to: 100, color: DS_CHART_TOKENS.rose100, label: 'Risk' },
                    ]),
                    plotLines: [buildTargetLine({ value: 20, label: 'Target', color: DS_CHART_TOKENS.green400 })],
                    max: 100
                  },
                  plotOptions: {
                    series: {
                      stacking: 'normal'
                    }
                  },
                  credits: {
                    enabled: false
                  },
                  series: []
              }
            }
        };
        this.diabitiesLocCallback = this.diabitiesLocCallback.bind(this)
        this.diabitiesGenderCallback = this.diabitiesGenderCallback.bind(this)
        this.diabitiesCompanyCallback = this.diabitiesCompanyCallback.bind(this)
    }
    componentWillMount () {
      this.getDiabitiesOverall()
      this.getDiabitiesGender()
      this.getDiabitiesLocation()
      this.getDiabitiesCompany()   
    }

    getDiabitiesCompany () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig) 
      baseConfig.config.chart.className = 'industry-diabetes-chart'
      baseConfig.config.subtitle.text = 'Industry wise distribution'
      this.setState({loading: true})
      window.axios.get(window.API_URL + 'corporate/dashboard/diabetic-trends/company-wise')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.xAxis = series.xAxis
        // baseConfig.config.yAxis = series.yAxis
        let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          b = b.filter( item => item )
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({diabitiesCompany: baseConfig, industry_data: response.data, allDiabitiesCompany: response.data, loading: false})
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: false})
      })
    }

    diabitiesCompanyCallback(filter) {
      let series = this.state.allDiabitiesCompany.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allDiabitiesCompany.filters
      baseConfig.config.subtitle.text = 'Industry wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.xAxis = series.xAxis
      // baseConfig.config.yAxis = series.yAxis
      let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({diabitiesCompany: baseConfig})
    }

    getDiabitiesLocation () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      this.setState({loading: true})
      baseConfig.config.subtitle.text = 'Location, Department & Shift wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/diabetic-trends/other-trends')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.xAxis = series.xAxis
        // baseConfig.config.yAxis = series.yAxis
        let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({diabitiesLocation: baseConfig, allDiabitiesLoc: response.data, loading: false})
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: true})
      })
    }
    diabitiesLocCallback (filter) {
      let series = this.state.allDiabitiesLoc.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allDiabitiesLoc.filters
      baseConfig.config.subtitle.text = 'Location, Department & Shift wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.xAxis = series.xAxis
      // baseConfig.config.yAxis = series.yAxis
      let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({diabitiesLocation: baseConfig})
    }

    getDiabitiesGender () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      this.setState({loading: true})
      baseConfig.config.subtitle.text = 'Gender wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/diabetic-trends/age-gender')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.xAxis = series.xAxis
        // baseConfig.config.yAxis = series.yAxis
        let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({diabitiesGender: baseConfig, allDiabitiesGender: response.data, loading: false})
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: true})
      })
    }
    diabitiesGenderCallback(filter) {
      let series = this.state.allDiabitiesGender.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allDiabitiesGender.filters
      baseConfig.config.subtitle.text = 'Gender wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.xAxis = series.xAxis
      // baseConfig.config.yAxis = series.yAxis
      let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({diabitiesGender: baseConfig})
    }

    getDiabitiesOverall () {
        let that = this
        let baseConfig = {
          filters: [],
          config: {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                className: 'overall-diabetes-chart'
            },
            title: {
                text: 'Diabetes',
                align: 'left'
            },
            subtitle: {
                text: '',
                align: 'left'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        distance: 20,
                        format: '{point.percentage:.1f} %',
                        style: {
                            color: 'black'
                        },
                        connectorColor: 'silver'
                    },
                    showInLegend: true
                }
            },
            credits: {
              enabled: false
            },
            series: [{
                name: 'Employees',
                data: []
            }]
          }
        }
        window.axios.get(window.API_URL + 'corporate/dashboard/diabetic-trends/overall')
        .then(function (response) {
          baseConfig.config.series[0].data = response.data.series
          baseConfig.config.subtitle.text = response.data.total_count + " Users"
          let diabetic_percent = 0
          let prediabetic_percent = 0
          let diabetic_prediabetic_percent = 0
          let diabetic_prediabetic_count = 0
          if (response.data.series.length > 0){
            let diabetic_data = response.data.series.find( a => a.name === 'Diabetic' );
            if (diabetic_data){
              diabetic_percent = diabetic_data.y ? diabetic_data.y : 0
            }
            let prediabetic_data = response.data.series.find( a => a.name === 'Pre-Diabetic' );
            if (prediabetic_data){
              prediabetic_percent = prediabetic_data.y ? prediabetic_data.y : 0
            }
            diabetic_prediabetic_percent = (diabetic_percent + prediabetic_percent).toFixed(1)
            diabetic_prediabetic_count = ((response.data.total_count*diabetic_prediabetic_percent)/100).toFixed(0)
            diabetic_prediabetic_percent = parseFloat(diabetic_prediabetic_percent).toFixed(0)
          }
          that.setState({diabitiesOverall: baseConfig, data: response.data.series, total_count: response.data.total_count, diabetic_prediabetic_percent: diabetic_prediabetic_percent, diabetic_prediabetic_count: diabetic_prediabetic_count})
        })
        .catch(function (error) {
          console.log(error);
        })
    }
    render () {
        return (
            <div className="gutter-example">
              <Spin spinning={this.state.loading}>
                <Card>  
                  <Row gutter={16}>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts filters={this.state.diabitiesOverall.filters} config={this.state.diabitiesOverall.config}/>
                          </div>
                      </Col>
                      <Col span={2}/>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts callback={this.diabitiesGenderCallback}
                              filters={this.state.diabitiesGender.filters} 
                              config={this.state.diabitiesGender.config}/>
                          </div>
                      </Col>
                  </Row>
                </Card>  
                <br></br>
                <Card>
                  <Row gutter={16}>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts callback={this.diabitiesLocCallback}
                              filters={this.state.diabitiesLocation.filters} 
                              config={this.state.diabitiesLocation.config}/>
                          </div>
                      </Col>
                      <Col span={2}/>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts callback={this.diabitiesCompanyCallback}
                              filters={this.state.diabitiesCompany.filters} 
                              config={this.state.diabitiesCompany.config}/>
                          </div>
                      </Col>
                  </Row>
                </Card>  
                <br/>
                <input type='hidden' id="diabetic_prediabetic_percent" value={this.state.diabetic_prediabetic_percent} />
                <input type='hidden' id="diabetic_prediabetic_count" value={this.state.diabetic_prediabetic_count} />
                <input type='hidden' id="diabetes_trends_data" value={JSON.stringify(this.state.data)} />
                <input type='hidden' id="diabetes_trends_count" value={this.state.total_count} />
                <input type='hidden' id="diabetes_trends_industry_data" value={JSON.stringify(this.state.industry_data)} />
              </Spin>  
            </div>
        )
    }
}
export default Diabities;
